import React, { FC, Fragment, useEffect, useState } from 'react';
import { Card, Form as AntForm, Descriptions, Spin, Button, Table } from 'antd';
import { FormComponentProps } from 'antd/es/form';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { services } from '@comall-backend-builder/core';
import DetailTitle from '../DetailTitle';
import { errorHandle } from '../../services';
import '../sunbathing-edit/index.less';
import moment from 'moment';

const api = services.api;

export interface CategoryFilterAttrTableProps {
    entity: Entity;
    params: any;
    componentId: string;
    form: FormComponentProps['form'];
}
export const SknsubstitutionDetailDom: FC = (props: any) => {
    const params = props.params || {};
    const id = params.id || '';
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState<any>({});
    const [tableData, setTableData] = useState([]);

    // 获取详情信息
    const handlleGetDetail = () => {
        setLoading(true);
        api.get({ orderid: id }, { apiPath: `/orderReplaceSkn/get_replace_order_detail` })
            .then((res: any) => {
                setDetail(res.resultBody || {});
                if (res.resultBody && res.resultBody.replaceOrderItemDtolist) {
                    setTableData(res.resultBody.replaceOrderItemDtolist || []);
                }
            })
            .catch(errorHandle)
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        handlleGetDetail();
        return () => {
            sessionStorage.setItem('fromSknSubstitution', 'true');
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const goBack = () => {
        services.navigation.goto('/trade/changeSKu');
    };

    const columns: any[] = [
        {
            title: '华夏款号',
            dataIndex: 'styleCode',
            width: 140,
            align: 'center',
        },
        {
            title: '原订单SKU',
            dataIndex: 'oldSku',
            width: 160,
            align: 'center',
        },
        {
            title: '原订单SKN',
            dataIndex: 'oldSkn',
            width: 160,
            align: 'center',
        },
        {
            title: '原订单商品名称',
            dataIndex: 'oldSkuName',
            width: 180,
            align: 'center',
        },
        {
            title: '原订单商品售价',
            dataIndex: 'oldSkuPrice',
            width: 130,
            align: 'center',
        },
        {
            title: '原商品库存位置',
            dataIndex: 'oldSkuWarehouseName',
            width: 210,
            align: 'center',
            render: (_: any, record: any) => {
                return record.oldSkuWarehouseCode && record.oldSkuWarehouseName
                    ? `${record.oldSkuWarehouseCode}-${record.oldSkuWarehouseName}`
                    : '';
            },
        },
        {
            title: '置换后sku',
            dataIndex: 'newSku',
            width: 160,
            align: 'center',
        },
        {
            title: '置换后skn',
            dataIndex: 'newSkn',
            width: 180,
            align: 'center',
        },
        {
            title: '置换后商品名称',
            dataIndex: 'newSkuName',
            width: 210,
            align: 'center',
        },
        {
            title: '置换后商品售价',
            dataIndex: 'newSkuPrice',
            width: 130,
            align: 'center',
        },
        {
            title: '置换后商品库存位置',
            dataIndex: 'newSkuWarehouseName',
            width: 210,
            align: 'center',
            render: (_: any, record: any) => {
                return record.newSkuWarehouseCode && record.newSkuWarehouseName
                    ? `${record.newSkuWarehouseCode}-${record.newSkuWarehouseName}`
                    : '';
            },
        },
    ];

    const statusDic = {
        1: '待审核',
        2: '已通过',
        3: '已驳回',
    };

    return (
        <Fragment>
            <Spin spinning={loading}>
                <div className="sunbathing-edit-dom">
                    <Card title="查看">
                        <DetailTitle label={'基本信息'} />
                        <Descriptions style={{ marginBottom: 20 }}>
                            <Descriptions.Item label="置换订单编号">
                                {detail.replaceOrderNo ?? '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="原销售订单编号">
                                {detail.orderNo ?? '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="创建时间">
                                {detail.createTime
                                    ? moment(detail.createTime).format('YYYY-MM-DD HH:mm:ss')
                                    : '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="状态">
                                {detail.status ? statusDic[detail.status] : '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="审核人">
                                {detail.checkUser || '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="审核时间">
                                {detail.checkTime
                                    ? moment(detail.checkTime).format('YYYY-MM-DD HH:mm:ss')
                                    : '--'}
                            </Descriptions.Item>
                            <Descriptions.Item label="审核意见">
                                {detail.checkReason || '--'}
                            </Descriptions.Item>
                        </Descriptions>

                        <DetailTitle label={'置换商品信息'} />
                        <Table
                            scroll={{ x: 1800 }}
                            rowKey="id"
                            loading={loading}
                            columns={columns}
                            dataSource={tableData}
                            pagination={false}
                        />
                        <div className="footer-btn" style={{ marginBottom: 40 }}>
                            <Button onClick={goBack}>返回</Button>
                        </div>
                    </Card>
                </div>
            </Spin>
        </Fragment>
    );
};

export const SknsubstitutionDetail = AntForm.create<CategoryFilterAttrTableProps>()(
    SknsubstitutionDetailDom
);
